import React from "react";
import { bool, func, string } from "prop-types";
import { useTranslation } from "@lib/i18n";

import ArrowLeftIcon from "../../shared/Icons/ArrowLeft";
import Icon from "@components/shared/Icons/Icon";
import Typography from "../../shared/Typography";

const ShownPackage = ({
  onClick,
  title,
  backgroundUrl,
  preventClose = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="
        flex flex-col justify-between items-start
        w-full h-39 p-4 relative
        bg-no-repeat bg-right bg-cover rounded-md overflow-hidden
        shadow-sm shadow-primaryOrange/10
        cursor-pointer uppercase
      "
      style={{ backgroundImage: backgroundUrl }}
    >
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/30 to-black/0 z-0" />
      {!preventClose && (
        <button
          className="flex items-center text-white transition duration-150 hover:text-greyLight cursor-pointer relative z-1"
          data-id={`customize-package-${title}-close-button`}
          onClick={onClick}
        >
          <Icon className="w-6 h-4 mr-2" icon={<ArrowLeftIcon />} />
          <span className="text-sm uppercase font-semibold">
            {t("customize.close")}
          </span>
        </button>
      )}
      <Typography
        className="text-white uppercase font-semibold relative z-1"
        data-id={`customize-package-title-${title}`}
      >
        {title}
      </Typography>
    </div>
  );
};

ShownPackage.propTypes = {
  backgroundUrl: string.isRequired,
  onClick: func,
  preventClose: bool,
  title: string.isRequired,
};

export default ShownPackage;
